import { render } from "./TitleTaskPreSvgIcon.vue?vue&type=template&id=a381ee5a"
import script from "./TitleTaskPreSvgIcon.vue?vue&type=script&lang=js"
export * from "./TitleTaskPreSvgIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__